
<div class="bg-white {{class}}">
  <div class="bg-e-white md:py-[50px] rounded-xl">
    <div class="container-default flex flex-col-reverse md:flex-row md:justify-between px-6">
      <div class="flex flex-col items-start justify-center md:w-1/3 md:me-6">
        <h1 class="" itemprop="name">{{_product?.title || _product?.name}}</h1>
        <h4 class="">{{_product?.subtitle}}</h4>
        <i class=""><small>{{_product?.shopquantity}} {{'unit.' + _product?.shopunit | translate }}</small></i>
        <div class="my-5" [innerHTML]="_product?.shortdescription | safeHtml"></div>
        @if ((qtyeditable || repeatableeditable) && _product.shopsellprice) {
          @if (_product?.discountprice > 0 ||_product?.discountpercentage > 0) {
            <div class="bg-e-gold text-white rounded-full px-2">
              <small>
                @if (_product?.discountpercentage >0) {
                  {{calculatedPrice?.calculateddiscountpercentage}}% {{'common.discount' | translate}}
                } @else {
                  {{calculatedPrice?.discountincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} {{'common.discount' | translate}}
                }
              </small>
            </div>
          }
          <pricetag [productprice]="true" [calculatedPrice]="calculatedPrice"></pricetag>
          @if (!repeatable.value && deliverydate) {
            <small class="text-secondary">{{'subscription.delivery_of' | translate}} {{deliverydate | localizedDate :'EEEE d MMMM' |lowercase}}</small>
          }
          <div class="flex w-full justify-between mt-6">
            <span class="my-auto me-2">{{'common.quantity' | translate}}</span>
            <app-quantityselection class="w-2/3" [quantity]="quantity.value" (quantityChange)="setQuantity($event)" [contrastColorscheme]="colorscheme"></app-quantityselection>
          </div>
          @if (repeatableeditable) {
            <app-toggle class="mt-6" [formControl]="repeatable">{{'subscription.product_weekly' | translate}}</app-toggle>
          }
        }
      </div>

      <div class="md:w-2/3">
        <app-image [imageobject]="_product" size="lg" alt="{{_product?.title}}" class="rounded-3xl object-cover w-full"></app-image>
      </div>
    </div>
    <div class="hidden md:flex w-[39px] h-[39px] icon-round mx-auto mt-6">
      <img _ngcontent-serverapp-c211="" src="./assets/images/icons/arrow_down.svg" class="h-5 w-5">
    </div>
  </div>
  <div class="container-default flex flex-col md:flex-row px-6 mt-6" id="main">
    <div class="w-full md:w-3/5 md:ms-6">
      <div class="my-5" [innerHTML]="_product?.description | safeHtml"></div>
    </div>
    <div class="w-full md:w-2/5 md:ml-[100px]">
      @if (_product?.nutrients.length >0) {
        <div class="flex flex-col bg-e-white rounded-lg p-5 my-6 md:m-6">
          <div class="flex flex-row justify-between">
            <h4 class="p-0">{{'nutrient.nutritional values' | translate}}</h4><small class="">{{'product.per portion'| translate}}</small>
          </div>
          @for (nutrient of _product?.nutrients; track nutrient) {
            <div class="flex flex-row justify-between border-b border-black mt-2 pb-2">
              <span class="px-0">{{'nutrient.' + nutrient.name | translate}}</span> <span class="px-0 text-end ">{{nutrient.quantity}} {{'unit_abbr.' + nutrient.unit |translate}}</span>
            </div>
          }
          @if (_product?.allergens.length >0) {
            <div class="mt-5">
              <span>{{'allergen.allergen information' | translate }}</span>
              <div class="flex flex-row flex-wrap mt-2 gap-2">
                @for (allergen of _product?.allergens; track allergen) {
                  <app-chip>
                    <span class="text-sm font-medium">{{'allergen.' + allergen.name | translate}}</span>
                  </app-chip>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>


